export const HEADER_OPTIONS = [
    "Accept-Language",
    "Authorization",
    "Client-Id",
    "Domain",
    "Service-Account",
    "Cache-Control",
    "Content-MD5",
    "From",
    "If-Match",
    "If-Modified-Since",
    "If-None-Match",
    "Max-Forwards",
    "Pragma",
    "If-Range",
    "If-Unmodified-Since",
    "Proxy-Authorization",
    "Range",
    "Warning",
    "x-api-key",
    "Accept-Charset",
    "Accept-Encoding",
    "Accept-Control-Request-Headers",
    "Accept-Control-Request-Method",
    "Content-Transfer-Encoding",
    "Expect",
    "Transfer-Encoding",
    "Trailer",
    "Custom",
];



export const TIMEOUT_POLICY_OPTIONS = [{
    "key": "Timeout Workflow",
    "value": "TIME_OUT_WF"
},
{
    "key": "Alert Only",
    "value": "ALERT_ONLY"
}];

